var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureCompatible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.732,
    height: 65.033,
    viewBox: "0 0 63.732 65.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "secure_compatible",
    "data-name": "secure&compatible",
    d: "M-18907.539,3675.727c-13.07-4.777-22.5-16.2-27.258-33.027a86.7,86.7,0,0,1-3.246-23.8v-.1l.119-2.305h2.324c2.4,0,9.467-.409,13.227-2.291,2.672-1.336,8.7-2.163,15.732-2.163s13.064.827,15.736,2.163c3.76,1.882,10.822,2.291,13.223,2.291h2.3l.057,2.3v.067a91.3,91.3,0,0,1-3.242,23.845c-4.682,16.839-14.115,28.265-27.281,33.037l-.836.3Zm-12.686-57.329-.1.052c-3.475,1.735-8.437,2.41-11.982,2.671l-.975.071.043.974a83.311,83.311,0,0,0,4.738,24.5c4.516,12.125,11.73,20.247,21.449,24.144l.371.147.375-.147c9.721-3.893,16.936-12.015,21.449-24.14a83.573,83.573,0,0,0,4.74-24.5l.041-.974-.973-.071c-3.551-.261-8.508-.936-11.982-2.671-2.439-1.193-8.664-1.621-13.68-1.621-2.357,0-10.213.109-13.393,1.516h-.006Zm11.973,35.261a2.225,2.225,0,0,1-.646-1.568v-16.112a2.223,2.223,0,0,1,1.107-1.92,2.228,2.228,0,0,1,1.107-.3,2.217,2.217,0,0,1,1.107.3,2.223,2.223,0,0,1,1.107,1.92v16.112a2.182,2.182,0,0,1-.646,1.564,2.185,2.185,0,0,1-1.568.651A2.206,2.206,0,0,1-18908.252,3653.659Z",
    transform: "translate(18938.551 -3611.534)",
    fill: "#FF00B8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureCompatible);
export default __webpack_public_path__ + "static/media/secure-compatible.54668d588d373d72213e2fc77d4a4869.svg";
export { ForwardRef as ReactComponent };